import SvgIcon from "@mui/material/SvgIcon";

interface DashboardIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function DashboardIcon({
  htmlColor,
  fontSize = "medium",
}: DashboardIconProps) {
  return (
    <SvgIcon viewBox="0 0 14 14" fontSize={fontSize}>
      <g clipPath="url(#clip0_dashboard_icon)">
        {/* Top left chart */}
        <rect
          x="1"
          y="1"
          width="5"
          height="5"
          rx="0.5"
          fill="none"
          stroke={htmlColor || "currentColor"}
          strokeWidth="0.5"
        />
        <path
          d="M1.5 4.5L2.5 3L3.5 4L4.5 2.5L5.5 3.5"
          stroke={htmlColor || "currentColor"}
          strokeWidth="0.5"
          fill="none"
        />

        {/* Top right chart */}
        <rect
          x="8"
          y="1"
          width="5"
          height="5"
          rx="0.5"
          fill="none"
          stroke={htmlColor || "currentColor"}
          strokeWidth="0.5"
        />
        <circle cx="9.5" cy="3.5" r="1" fill={htmlColor || "currentColor"} />
        <circle cx="11.5" cy="2.5" r="0.8" fill={htmlColor || "currentColor"} />
        <circle cx="12.5" cy="4.5" r="0.6" fill={htmlColor || "currentColor"} />

        {/* Bottom left chart */}
        <rect
          x="1"
          y="8"
          width="5"
          height="5"
          rx="0.5"
          fill="none"
          stroke={htmlColor || "currentColor"}
          strokeWidth="0.5"
        />
        <rect
          x="1.5"
          y="10"
          width="1"
          height="2.5"
          fill={htmlColor || "currentColor"}
        />
        <rect
          x="3"
          y="9"
          width="1"
          height="3.5"
          fill={htmlColor || "currentColor"}
        />
        <rect
          x="4.5"
          y="8.5"
          width="1"
          height="4"
          fill={htmlColor || "currentColor"}
        />

        {/* Bottom right chart */}
        <rect
          x="8"
          y="8"
          width="5"
          height="5"
          rx="0.5"
          fill="none"
          stroke={htmlColor || "currentColor"}
          strokeWidth="0.5"
        />
        <path
          d="M8.5 12.5L9.5 10.5L10.5 11.5L11.5 9.5L12.5 10.5"
          stroke={htmlColor || "currentColor"}
          strokeWidth="0.5"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_dashboard_icon">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
